import { grey } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
import { border, borderRadius, padding, width } from '@mui/system';

export const paletteOverides = {
    primary: {
        light: '#269411',
        main: '#06584D',
        dark: '#05463E',
        contrastText: '#FFFFFF',
        lightest: '#e0f5e8',
    },
    secondary: {
        light: '#E3F2FD',
        main: '#1976D2',
        border: '#bbdafa',
    },
    warning: {
        main: "#FCA02F",
        light: "#FFF4E5",
        dark: "#FFB74D",
        text: "#A15C00",
    },
    error: {
        light: "#F5DCDD",
        main: "#E34E54",
        border: "#F5C2C7"
    },
    success: {
        light: "#C4E6D1",
        main: "#2A9D56",
        dark: "#05463E"
    },
    text: { //v2
        secondary: '#efefef',
        secondaryLight: '#ffffff',
        light: '#505461',
        primary: '#121212',
        lightGrey: '#c4c4c4',
        grey: '#a3a4a4',
        darkGrey: '#505461',
        lowEmphasis: '#B9B9BA'
    },
    background: {
        main: '#06584D',
        primary: '#F8FAFB',
        secondary: '#ffffff',
        default: '#f6f6f6',
    },
    border: {
        light: "#E9E9E9"
    },

    other: {
        light: grey[800],
        main: grey[900],
        icon: "#8a8a8a",
        contrastText: "#fff"

    },

    gradient: {
        primary: 'radial-gradient(circle 100vh at 50% 25%, #003763 0%, #000 100%)',
        secondary: `radial-gradient(circle 100vh at 50% 25%, #613a00 0%, #000 100%)`,
        highlight: (color = 'red', color2 = "#E9E9E9") =>
            `linear-gradient(white, white) padding-box,
     linear-gradient(252.61deg, ${color} -12.74%, ${color2} 83.91%) border-box`,
        linearLight: 'linear-gradient(133deg, rgb(191 118 51 / 25%) -1.67%, rgb(137 78 160 / 25%) 28.04%, rgb(59 102 177 / 25%) 62.44%, rgb(251 73 72 / 25%) 102.58%)',

    },

    button: {
        light: "#d2f3d3",
        main: "#31BD68", //all button color green
    },
    sidebarLink: {
        main: '#0313cbfa', //links
        hover: '#a2a7bb',
        active: '#FFFFFF',
    },

}

export const otherOverides = {
    typography: {
        fontFamily: ['Inter', 'Poppins', 'Segoe UI', 'sans-serif',].join(','),
        // htmlFontSize: window.innerWidth < 600 ? 12 : 16,
        h1: {
            fontSize: '2rem', // ~32px (32 / 16 = 2rem)
            fontWeight: 500,
            '@media (min-width:600px)': {
                fontSize: '2.25rem', // 36px
            },
            '@media (min-width:900px)': {
                fontSize: '2.5rem', // 40px
            },
        },
        h2: {
            fontSize: '1.375rem', // ~22px
            fontWeight: 500,
            '@media (min-width:600px)': {
                fontSize: '1.5rem', // 24px
            },
            '@media (min-width:900px)': {
                fontSize: '1.75rem', // 28px
            },
        },
        h3: {
            fontSize: '1.25rem', // ~20px
            fontWeight: 500,
            '@media (min-width:600px)': {
                fontSize: '1.375rem', // 22px
            },
            '@media (min-width:900px)': {
                fontSize: '1.5rem', // 24px
            },
        },
        h4: {
            fontSize: '1.125rem', // ~18px
            fontWeight: 500,
            '@media (min-width:600px)': {
                fontSize: '1.25rem', // 20px
            },
            '@media (min-width:900px)': {
                fontSize: '1.375rem', // 22px
            },
        },
        h5: {
            fontSize: '1rem', // 16px
            fontWeight: 500,
            '@media (min-width:600px)': {
                fontSize: '1.125rem', // 18px
            },
            '@media (min-width:900px)': {
                fontSize: '1.25rem', // 20px
            },
        },
        h6: {
            fontSize: '0.875rem', // 14px
            fontWeight: 500,
            '@media (min-width:600px)': {
                fontSize: '1rem', // 16px
            },
            '@media (min-width:900px)': {
                fontSize: '1.125rem', // 18px
            },
        },
        subtitle1: {
            fontSize: '0.875rem', // 14px
            fontWeight: 400,
            '@media (min-width:600px)': {
                fontSize: '0.875rem', // 14px
            },
            '@media (min-width:900px)': {
                fontSize: '1rem', // 16px
            },
        },
        subtitle2: {
            fontSize: '0.75rem', // 12px
            fontWeight: 100,
            '@media (min-width:600px)': {
                fontSize: '0.75rem', // 12px
            },
            '@media (min-width:900px)': {
                fontSize: '0.875rem', // 14px
            },

        },
        body1: {
            fontSize: '0.875rem', // 14px
            '@media (min-width:600px)': {
                fontSize: '1rem', // 16px
            },
            '@media (min-width:900px)': {
                fontSize: '1.125rem',// 18px
            },
        },
        body2: {
            fontSize: '0.75rem', // 12px
            '@media (min-width:600px)': {
                fontSize: '0.875rem', // 14px
            },
            '@media (min-width:900px)': {
                fontSize: '1rem', // 16px
            },
        },
        caption: {
            fontSize: '0.75rem', // 12px
            '@media (min-width:600px)': {
                fontSize: '0.75rem', // 12px
            },
            '@media (min-width:900px)': {
                fontSize: '0.875rem', // 14px
            },
        },
        button: {
            fontSize: '0.75rem', // 12px
            textTransform: 'normal',
            '@media (min-width:600px)': {
                fontSize: '0.875rem', // 14px
            },
            '@media (min-width:900px)': {
                fontSize: '1rem', // 16px
            },
        },
        overline: {
            fontSize: '0.625rem', // 10px
        },
    },
    props: {
        MuiButton: {
            size: 'small',
        },
        MuiButtonGroup: {
            size: 'small',
        },
        MuiCheckbox: {
            size: 'small',
        },
        MuiFab: {
            size: 'small',
        },
        MuiFormControl: {
            margin: 'dense',
            size: 'small',
        },
        MuiFormHelperText: {
            margin: 'dense',
        },
        MuiIconButton: {
            size: 'small',
        },
        MuiInputBase: {
            margin: 'dense',
        },
        MuiInputLabel: {
            margin: 'dense',
        },
        MuiRadio: {
            size: 'small',
        },
        MuiSwitch: {
            size: 'small',
        },
        MuiTextField: {
            margin: 'dense',
            size: 'small',
        },
        MuiList: {
            size: 'small',
        },
        MuiMenuItem: {
            size: 'small',
        },
        MuiTable: {
            size: 'small',
        },
        MuiTooltip: {
            arrow: true,
        },
    },
    components: {
        MuiCheckbox: {
            styleOverrides: {
                root: ({ theme }) => ({
                    // Default (unchecked)
                    //   color: "#e0e0e0",

                    "&.Mui-checked": {
                        color: theme.palette.primary,
                    },

                    "&:hover": {
                    },
                    "& .MuiSvgIcon-root": {
                        // fontSize: 20, // icon size
                        borderRadius: 2, // rounded checkbox corners
                    },

                    // Disabled state
                    "&.Mui-disabled": {
                    },
                }),
            },
        },
        MuiButton: {
            defaultProps: {
                // disableRipple: true,
            },
            styleOverrides: {
                root: ({ theme }) => ({
                    // borderRadius: "30px",
                    '& .MuiButton-startIcon': {
                        // marginRight: theme.spacing(0.5),
                        '& .MuiSvgIcon-root': {
                            // color: `${theme.palette.other.icon}`,
                        }
                    }
                }),
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: ({ theme }) => ({
                    // color: `${theme.palette.icon.main}`,
                }),
            },
        },
        MuiButtonBase: {
            defaultProps: {
                // disableRipple: true,
            },
        },
        MuiTooltip: {
            defaultProps: {
                arrow: true,
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: ({ theme }) => ({
                    // borderRadius: '12px !important',
                    // backgroundColor: theme.palette.background.extraDark,
                    '.MuiOutlinedInput-notchedOutline': {
                        // border: 0,
                    },
                    '.MuiSelect-select': {
                        // borderRadius: "12px !important",
                    },
                }),
            },
        },

        MuiTextField: {
            defaultProps: {
                fullWidth: true,
            },
            styleOverrides: {
                root: ({ theme }) => ({
                    '& .MuiInputBase-input': {
                        borderRadius: '12px !important',
                        padding: '14px 12px',
                        // backgroundColor: theme.palette.background.extraDark
                    },
                    '& .MuiInputBase-root': {
                        // backgroundColor: theme.palette.background.extraDark,
                        '.MuiOutlinedInput-notchedOutline': {
                            // border: 0,
                        }
                    },

                }),
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                },
                notchedOutline: {
                    borderRadius: 12,
                },
                select: {
                    padding: "10px 12px",
                    borderRadius: '12px !important',
                    display: "flex",
                    alignItems: "center",
                },

                icon: {
                    right: 0, // move dropdown arrow
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: ({ theme }) => ({
                    '& .MuiInputBase-input': {
                        backgroundColor: theme.palette.background.extraDark
                    },
                    '& .MuiInputBase-root': {
                        borderRadius: '12px !important',
                        backgroundColor: theme.palette.background.extraDark,
                    },

                }),
            },
        },
        MuiList: {
            styleOverrides: {
                root: ({ theme }) => ({
                    paddingTop: 0,
                    paddingBottom: 0,
                }),
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: ({ theme }) => ({
                    // borderColor: theme.palette.border.main,
                }),
            },
        },
        MuiLink: {
            styleOverrides: {
                root: ({ theme }) => ({
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    '&:hover': {
                        color: theme.palette.primary.dark,
                        textDecoration: 'none',
                    },
                }),
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: ({ theme }) => ({

                    '& .MuiDataGrid-columnHeaders': {
                        fontSize: theme.typography.h6.fontSize,

                        " .MuiDataGrid-columnHeader": {
                            // height: "40px !important"
                            outline: "none !important",
                        },
                    },
                    "& .MuiDataGrid-columnHeaders > div": {
                        backgroundColor: `${theme.palette.others.main} !important`,

                    },
                    '& .MuiDataGrid-row': {
                        color: theme.palette.text.secondary,
                        backgroundColor: `${theme.palette.background.default}`

                    },
                    '& .MuiDataGrid-cell': {
                        fontSize: theme.typography.h6.fontSize,
                    },


                }),
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: ({ theme }) => ({
                    '&:first-of-type': {
                        paddingRight: 4,
                        borderTopLeftRadius: 10,
                        borderTopRightRadius: 10,
                    },
                    '&:last-of-type': {
                        paddingRight: 4,
                        borderBottomLeftRadius: 10,
                        borderBottomRightRadius: 10,
                    },
                    boxShadow: "none",
                    backgroundColor: theme.palette.background.dark,
                    marginBottom: 0,
                    backgroundImage: "none !important",
                    "::before": { height: 0 }

                })
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: ({ theme }) => ({
                    backgroundColor: theme.palette.background.extraDark,

                    minHeight: "48px",
                    // borderRadius: "10px 10px 0px 0px",
                    marginBottom: 8,
                    "&.Mui-expanded": {
                        // minHeight: "48px",
                    },
                    "& .MuiAccordionSummary-content": {
                        margin: "0px 0",
                    },
                    "&.Mui-expanded .MuiAccordionSummary-content": {
                        margin: "0px 0",
                        marginBottom: 0,
                    },
                    // "& .MuiAccordionSummary-expandIconWrapper": {
                    //     backgroundColor: theme.palette.background.dark,
                    //     borderRadius: "50%",
                    //     padding: "4px",
                    // }
                }),
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: ({ theme }) => ({
                    marginBottom: 0,
                    padding: '0px',
                    // border: "1px solid", borderColor: theme.palette.border.main,
                    boxShadow: "none",
                    borderRadius: "0px 0px 10px 10px",
                    // .MuiAccordionDetails - root': {
                    backgroundColor: theme.palette.background.extraDark,
                }),
            }
        },

        MuiAutocomplete: {
            styleOverrides: {
                root: ({ theme }) => ({
                    ".MuiAutocomplete-tag": {
                        // maxWidth: "calc(100% - 80px)"
                    }
                }),
            }
        },

        MuiPickersDay: {
            styleOverrides: {
                root: {
                    fontSize: '12px',
                    "& .MuiDayCalendar-weekDayLabel": {
                        fontSize: '12px',
                    },
                },
            },
        },
        MuiDayCalendar: {
            styleOverrides: {
                weekDayLabel: {
                    fontSize: '12px',
                    color: "black",
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginLeft: '0px',

                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                root: ({ theme }) => ({
                    "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.dark,
                        backgroundImage: "none",
                    }
                })
            },
        },
    },
}


export const light = createTheme({
    palette: {
        type: 'light',
        ...paletteOverides,
    },
    ...otherOverides,


});
export const dark = createTheme({
    palette: {
        type: 'dark',
        ...paletteOverides,
    },
    ...otherOverides,

});









